// BusinessFilter.jsx
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  GetCustomFields,
  clearBusinessFilters,
  toggleQuestionOpen,
  toggleFilterOption,
  restoreFilterSelections,
  clearFilterSelectionsOnly,
} from "../../../redux/slices/CustomFieldsSlice";
import { setSelectedBusinessDetails } from "../../../redux/slices/bwvSlice";
import { motion, AnimatePresence } from "framer-motion";
import { FaChevronDown, FaChevronRight } from "react-icons/fa";
import "./BrowseWeddingVendors.css";

const BusinessFilter = ({ selectedCat }) => {
  const dispatch = useDispatch();

  const {
    catCustomFields,
    loadingCustomFields,
    errorCustomFields,
    selectedFilters,
    openQuestions,
  } = useSelector((state) => state.customFields);

  const selectedBusinessDetails = useSelector(
    (state) => state.bwvData.selectedBusinessDetails,
  );
  const hasActiveFilters = Object.values(selectedFilters).some((field) =>
    Object.values(field).some(Boolean),
  );
  // Load fields when category changes
  useEffect(() => {
    if (selectedCat?.Id || selectedCat?.id) {
      dispatch(GetCustomFields(selectedCat.Id || selectedCat.id));
    }
  }, [selectedCat, dispatch]);

  // Restore selections from saved string
  useEffect(() => {
    if (
      !loadingCustomFields &&
      catCustomFields.length > 0 &&
      selectedBusinessDetails &&
      typeof selectedBusinessDetails === "string" &&
      selectedBusinessDetails.trim()
    ) {
      dispatch(
        restoreFilterSelections({
          fields: catCustomFields,
          savedString: selectedBusinessDetails,
        }),
      );
    }
  }, [catCustomFields, selectedBusinessDetails, loadingCustomFields, dispatch]);

  const parseCustomValue = (customValue) => {
    if (!customValue) return [];
    try {
      const parsed = JSON.parse(customValue);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  };

  const getCountFromOption = (option) => {
    const match = option.toString().match(/-(\d+)$/);
    return match ? parseInt(match[1], 10) : 0;
  };

  const getTotalSelectedCount = () => {
    let total = 0;
    Object.values(selectedFilters).forEach((opts) => {
      Object.keys(opts).forEach((opt) => {
        if (opts[opt]) total += getCountFromOption(opt);
      });
    });
    return total;
  };

  const totalResultsCount = getTotalSelectedCount();

  const handleViewResults = () => {
    const allSelected = Object.values(selectedFilters)
      .flatMap((opts) => Object.keys(opts).filter((k) => opts[k]))
      .join(",");

    dispatch(setSelectedBusinessDetails(allSelected));
  };

  const handleClearFilters = () => {
    dispatch(setSelectedBusinessDetails(""));
    dispatch(clearFilterSelectionsOnly());
  };

  if (loadingCustomFields) {
    return (
      <div
        style={{ height: "50vh", padding: "40px 20px", textAlign: "center" }}
      >
        <div
          className="spinner"
          style={{
            width: "40px",
            height: "40px",
            border: "4px solid #f0f0f0",
            borderTop: "4px solid #00c4b4",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
            margin: "0 auto 16px",
          }}
        ></div>
        <p style={{ color: "#666", margin: 0 }}>Loading filters...</p>
      </div>
    );
  }

  if (errorCustomFields || !catCustomFields?.length) {
    return (
      <div style={{ padding: "30px 20px", textAlign: "center", color: "#666" }}>
        No filters available
      </div>
    );
  }

  return (
    <div style={{ position: "relative", fontFamily: "system-ui, sans-serif" }}>
      <div style={{ maxHeight: "70vh", overflowY: "auto" }}>
        {catCustomFields.map((field) => {
          const isOpen = !!openQuestions[field.id];
          const options = parseCustomValue(field.customValue);
          const fieldSelections = selectedFilters[field.id] || {};
          const selectedCount = Object.keys(fieldSelections).length;

          return (
            <div key={field.id} style={{ borderBottom: "1px solid #e5e7eb" }}>
              <div
                // onClick={() => dispatch(toggleQuestionOpen(field.id))}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  cursor: "pointer",
                  padding: "12px 0",
                }}
              >
                <h6
                  style={{
                    margin: 0,
                    fontWeight: 600,
                    fontSize: "0.95rem",
                    color: "#111827",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  {/* {isOpen ? (
                    <FaChevronDown size={14} color="#666" />
                  ) : (
                    <FaChevronRight size={14} color="#666" />
                  )} */}
                  {field.Question}
                </h6>
              </div>

              <AnimatePresence>
                {isOpen && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3, ease: "easeInOut" }}
                    style={{ overflow: "hidden" }}
                  >
                    <div>
                      {options.map((option) => {
                        const checked = !!fieldSelections[option];
                        const displayName = option.replace(/-\d+$/, "").trim();

                        return (
                          <label
                            key={option}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "12px",
                              marginBottom: "8px",
                              cursor: "pointer",
                            }}
                          >
                            <input
                              type="checkbox"
                              checked={checked}
                              onChange={() =>
                                dispatch(
                                  toggleFilterOption({
                                    fieldId: field.id,
                                    optionValue: option,
                                  }),
                                )
                              }
                              style={{
                                width: "17px",
                                height: "17px",
                                accentColor: "#1b99a8",
                                cursor: "pointer",
                              }}
                            />
                            <span style={{ fontSize: "0.9rem", color: "#333" }}>
                              {displayName || option}
                            </span>
                          </label>
                        );
                      })}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          );
        })}
      </div>
      <div className="filter-apply-container gap-2">
        {hasActiveFilters && (
          <button
            className="filter-clear-bottom-btn-business"
            onClick={handleClearFilters}
          >
            Clear All
          </button>
        )}

        <button className="filter-view-results-btn" onClick={handleViewResults}>
          View Results
          {/* {totalResultsCount ? `(${totalResultsCount})` : ""} */}
        </button>
      </div>
    </div>
  );
};

export default BusinessFilter;
